export enum ActionTypes {
  CLOSE_WIDGET_WITH_CONFIRMATION = "CLOSE_WIDGET_WITH_CONFIRMATION",
  DD_TIMING_EVENT_STOP = "DD_TIMING_EVENT_STOP",
  UPDATE_USER_INPUT = "UPDATE_USER_INPUT",
  WIDGET_LANGUAGE_SWITCHED = "WIDGET_LANGUAGE_SWITCHED",
  UPDATE_PERSISTENT_MENU = "UPDATE_PERSISTENT_MENU",
  CLOSE_WIDGET_WITHOUT_CONFIRMATION = "CLOSE_WIDGET_WITHOUT_CONFIRMATION",
  END_CONVERSATION = "END_CONVERSATION",
  UNDO_END_CONVERSATION = "UNDO_END_CONVERSATION",
  SWITCH_LANGUAGE = "SWITCH_LANGUAGE",
  BOT_LOADER_LANGUAGE_SWITCHED = "BOT_LOADER_LANGUAGE_SWITCHED",
  USER_ACTION_EVENT = "USER_ACTION_EVENT",
  OPEN_WIDGET = "OPEN_WIDGET",
  CLOSE_WIDGET = "CLOSE_WIDGET",
  KEEP_CHATTING = "KEEP_CHATTING",
  NATERA_START_CONVERSATION = "NATERA_START_CONVERSATION",
  CONTINUE_LANGUAGE_SWITCHING = "CONTINUE_LANGUAGE_SWITCHING",
  CANCEL_LANGUAGE_SWITCHING = "CANCEL_LANGUAGE_SWITCHING",
  CONFIRM_PARTNER_INFO = "CONFIRM_PARTNER_INFO",
  PROCESS_PARTNER_INFORMATION = "PROCESS_PARTNER_INFORMATION",
  PANORAMA_VIDEO_TIMEOUT = "PANORAMA_VIDEO_TIMEOUT",
  PANORAMA_VIDEO_LOADED = "PANORAMA_VIDEO_LOADED",
}

export enum MessageTypes {
  INTRO = "intro",
  TEXT = "text",
  ATTACHMENT = "attachment",
  VIDEO_ATTACHMENT = "video_attachment",
  GENERIC_TEMPLATE = "generic_template",
  TYPING = "TYPING",
}

export enum ButtonTypes {
  POSTBACK = "postback",
  WEB_URL = "web_url",
  TRANSCRIPT = "transcript",
  DROPDOWN = "dropdown",
  RATING = "rating",
  ENTER_PARTNER_INFORMATION = "enter_partner_information",
  EDIT_PARTNER_INFORMATION = "edit_partner_information",
}

export enum AttributeNames {
  BUTTON_STYLE_TYPE = "button_style_type",
  QUICK_REPLY_TYPE = "quick_reply_type",
  UPDATE_MESSAGES = "updateMessages",
}

export enum AttributeValues {
  TRUE = "true",
  FALSE = "false",
  PRIMARY = "PRIMARY",
  SECONDARY = "secondary",
}

export enum KeyTypes {
  ENTER = "enter",
  ESCAPE = "escape",
  TAB = "tab",
  SPACE = " ",
}

export enum NEVA_HEAP_EVENTS {
  BOT_LOADED_FIRST = "bot_loaded_first",
  BOT_LOADED_NTH = "bot_loaded_nth",
  MENU_OPEN = "menu_open",
  EF_REVIEW = "ef_review",
  EF_REVIEW_CANCEL = "ef_review_cancel",
  EF_REVIEW_PROCEED = "ef_review_proceed",
  UPP_VIDEO25PERC = "upp_video25perc",
  UPP_VIDEO50PERC = "upp_video50perc",
  UPP_VIDEO75PERC = "upp_video75perc",
  UPP_VIDEO100PERC = "upp_video100perc",
  VIDEO_CLICK = "video_click",
  POS_GEN_VIDEO_TIMEOUT = "pos_gen_video_timeout",
  HIGH_RISK_VIDEO_TIMEOUT = "high_risk_video_timeout",
  PARTNER_INFO_FORM_CLICK = "partner_info_form_click",
  PARTNER_INFO_FORM_CLICK_EDIT = "partner_info_form_click_edit",
  PARTNER_INFO_FORM_SUBMIT = "partner_info_form_submit",
}

export enum PostMessageEventTypes {
  QUESTIONNAIRE_CHAT_ID = "questionnaire-chatId",
  OPPORTUNITY_TO_RETURN = "opportunityToReturn",
  QUESTIONNAIRE_CONTENT_LOADED = "questionnaire-content-loaded",
  QUESTIONNAIRE_CLOSE_IFRAME_SUCCESSFULLY = "questionnaire-close_iframe_successfully",
  QUESTIONNAIRE_IFRAME_STATE = "questionnaire-iframe-state",
  QUESTIONNAIRE_ACTIVITY_EVENT = "questionnaire-activity-event",
}

export const iframeDefaultConfig = {
  isOpenIframe: false,
  isLoading: true,
  isShowIframe: false,
  url: "",
  isQuestionnaireIframeOpened: false,
  opportunityToManualClose: true,
  widgetIframeSource: null,
};

export const SANITIZE_OPTIONS = {
  ADD_ATTR: ["activity-event"],
};

export const nevaEventContent = {
  NEVAHorizonDiseaseSpecific: "NEVA_Horizon_disease_specific",
  NEVAPanoramaDiseaseSpecific: "NEVA_Panorama_disease_specific",
};

export enum VideoAuthorCode {
  AN = "an",
  NT = "nt",
}
